function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#343434",
  d: "M208 0l-3 10v275l3 3 128-76z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#8C8C8C",
  d: "M208 0L80 212l128 76V154z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3C3C3B",
  d: "M208 312l-2 2v98l2 5 128-180z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#8C8C8C",
  d: "M208 417V312L80 237z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#141414",
  d: "M208 288l128-76-128-58z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#393939",
  d: "M80 212l128 76V154z"
});

function SvgEther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 417 417",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEther);
export default __webpack_public_path__ + "static/media/Ether.6183a393.svg";
export { ForwardRef as ReactComponent };